import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  getLatestInformationDetail,
  getNewsLatterSubscriptionDetail,
} from "@/api/actions/information-pop-up-actions";

export const informationPopUpQuery = createQueryKeys("pop-up", {
  // Get latest information pop up data
  getLatestInformationDetail: () => ({
    queryKey: ["latest-information"],
    queryFn: () =>
      getLatestInformationDetail({
        populate: "deep",
      }),
  }),

  // Get news latter pop up data
  getNewsLatterSubscriptionDetail: () => ({
    queryKey: ["News-latter-pop-up"],
    queryFn: () =>
      getNewsLatterSubscriptionDetail({
        populate: "deep",
      }),
  }),
});
